import React from 'react';
import SamedayPickup from 'yoda-core-components/lib/assets/svg/YdtBopisStore.svg';
import Truck from 'yoda-core-components/lib/assets/svg/IconTruck.svg';
import Return from 'yoda-core-components/lib/assets/svg/iconsUtilityReturn.svg';
import TrackOrder from 'yoda-core-components/lib/assets/svg/TrackOrder.svg';
import WhiteGlove from 'yoda-core-components/lib/assets/svg/iconsUtilityFulfillment.svg';

const shippingTags = {
    SameDayPickUp: {
        title: 'Same Day Pick Up',
        icon: 'sameday-pickup',
        iconComponent: <SamedayPickup />,
        html: 'Need it right away? Confirm availability & buy online, pick it up at your store.',
        imgDimention: '24px',
        order: 1,
    },
    ShipToHome: {
        title: 'Convenient Shipping Options',
        icon: 'truck',
        iconComponent: <Truck />,
        html:
            'Not available at your store? We can ship to you directly or to your favorite JCP location.',
        imgDimention: '18px',
        order: 2,
    },
    CustomBlindsReturns: {
        id: 'returns',
        title: 'Returns',
        icon: 'return',
        iconComponent: <Return />,
        html:
            'Custom Blinds, Shades, and Draperies orders are custom fabricated to your specifications. The order must be cancelled within 24 hours of the initial transaction to receive a refund. ',
        link: 'returns policy.',
        imgDimention: '24px',
        order: 3,
    },
    EasyReturns: {
        id: 'returns',
        title: 'Easy Returns',
        icon: 'return',
        iconComponent: <Return />,
        html: 'Shop with confidence. Read our full, common sense ',
        link: 'returns policy.',
        imgDimention: '19px',
        order: 4,
    },
    truck: {
        id: 'truck-delivery',
        title: 'Truck Delivery',
        icon: 'truck',
        iconComponent: <Truck />,
        html:
            'Some heavy or bulky items cannot be delivered via UPS, USPS or FedEx. These items must be delivered via truck. Additional fees may apply. ',
        link: 'See Details',
        imgDimention: '18px',
        order: 6,
    },
    deluxed: {
        title: 'Deluxe Delivery',
        icon: 'track-order',
        iconComponent: <TrackOrder />,
        html:
            'Delivery agents will unpack, assemble, inspect, touch up and rewrap item prior to delivery. Agents will deliver item to your room of choice and remove all packaging materials.',
        imgDimention: '24px',
        order: 7,
    },
    roomOfChoice: {
        title: 'Room of Choice Delivery',
        icon: 'track-order',
        iconComponent: <TrackOrder />,
        html:
            'Delivery agents will deliver packed items to your room of choice. Unpacking will be required. Assembly may be required.',
        imgDimention: '24px',
        order: 8,
    },
    whiteGlove: {
        title: 'White glove delivery',
        icon: 'track-order',
        iconComponent: <WhiteGlove />,
        html:
            'This item includes White Glove Delivery, our highest level of service. We unpack and assemble your item in any room, in any configuration, and remove all shipping and packing material when we leave.',
        imgDimention: '24px',
        order: 9,
    },
    threshold: {
        title: 'Threshold Delivery',
        icon: 'track-order',
        iconComponent: <TrackOrder />,
        html:
            'Delivery agents will deliver packaged item just inside entryway. Unpacking will be required. Assembly may be required.',
        imgDimention: '24px',
        order: 10,
    },
};

export const marketPlaceShippingTags = [
    {
        title: 'Shipping',
        icon: 'truck',
        iconComponent: <Truck />,
        html:
            'Third-Party Seller items are shipped directly from the seller. Shipping methods, delivery timing, and availability may vary by seller and item.',
        imgDimention: '18px',
        order: 1,
    },
    {
        id: 'returns',
        title: 'Returns',
        icon: 'return',
        iconComponent: <Return />,
        html:
            'Most Third-Party Seller items may be returned in accordance with our Marketplace Returns Policy. Return eligibility and requirements may vary by seller. See our Returns Policy for complete details.',
        imgDimention: '19px',
        order: 2,
    },
];

export const SHIPPING_TAGS_SORT_KEY = 'order';

export default shippingTags;
